/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any -- Additional Data doesn't have any type */
import './grid.scss'
import type { FC } from 'react'
import type { CineColombiaGridRow } from './grid.types'
import { GridRowComponent } from './GridRowComponent'

export interface GridProps {
    rows: CineColombiaGridRow[] | undefined
    additionalData?: any
}

export const Grid: FC<GridProps> = props => {
    if (props.rows && props.rows.length > 0) {
        return (
            <div className="grid">
                {props.rows.map((row, index) => (
                    <GridRowComponent key={'grid-row-' + index} {...row} additionalData={props.additionalData} />
                ))}
            </div>
        )
    }
    return null
}
